import React from 'react'

import Icon from '@/components/common/Icon'

const IconCard: React.FC<{
  className?: string
  width?: number
  height?: number
}> = ({ className, height, width }) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 200 200"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5317_57499)">
      <path
        d="M119.583 65.0361H80.313V135.605H119.583V65.0361Z"
        fill="#FF5F00"
      />
      <path
        d="M82.8066 100.32C82.8004 93.524 84.3405 86.8153 87.3102 80.7022C90.28 74.5891 94.6017 69.2318 99.948 65.0358C93.3273 59.8317 85.3761 56.5954 77.003 55.6968C68.63 54.7981 60.173 56.2732 52.5988 59.9537C45.0245 63.6342 38.6385 69.3714 34.1707 76.5097C29.703 83.6479 27.3337 91.8991 27.3337 100.32C27.3337 108.741 29.703 116.993 34.1707 124.131C38.6385 131.269 45.0245 137.006 52.5988 140.687C60.173 144.367 68.63 145.842 77.003 144.944C85.3761 144.045 93.3273 140.809 99.948 135.605C94.6017 131.409 90.2801 126.051 87.3103 119.938C84.3405 113.825 82.8004 107.117 82.8066 100.32V100.32Z"
        fill="#EB001B"
      />
      <path
        d="M172.56 100.32C172.56 108.741 170.191 116.992 165.724 124.131C161.256 131.269 154.871 137.006 147.296 140.687C139.722 144.367 131.265 145.842 122.893 144.944C114.52 144.045 106.569 140.809 99.948 135.605C105.29 131.405 109.608 126.046 112.577 119.934C115.547 113.822 117.089 107.115 117.089 100.32C117.089 93.525 115.547 86.8185 112.577 80.7063C109.608 74.5942 105.29 69.236 99.948 65.0357C106.569 59.8317 114.52 56.5954 122.893 55.6967C131.265 54.7981 139.722 56.2733 147.296 59.9538C154.871 63.6343 161.256 69.3716 165.724 76.5098C170.191 83.6481 172.56 91.8993 172.56 100.32V100.32Z"
        fill="#F79E1B"
      />
      <path
        d="M168.278 128.131V126.686H168.861V126.392H167.377V126.686H167.96V128.131H168.278ZM171.159 128.131V126.389H170.704L170.181 127.587L169.658 126.389H169.203V128.131H169.524V126.817L170.014 127.95H170.347L170.838 126.814V128.131H171.159Z"
        fill="#F79E1B"
      />
    </g>
    <defs>
      <clipPath id="clip0_5317_57499">
        <rect width="200" height="200" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default Icon(IconCard)
